import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const materials = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">Programming ATtiny45 using USBasp</Typography>
      <Typography className={classes.para} paragraph>
        USBasp is USB programmer for Atmel AVR controllers. I needed{" "}
        <Link
          target="_blank"
          href={
            "https://www.microchip.com/mplab/avr-support/avr-and-arm-toolchains-c-compilers"
          }
        >
          Atmel AVR Toolchain for Windows
        </Link>
        , GNU Make, avrdude for setting up my programmer. I followed{" "}
        <Link
          target="_blank"
          href={
            "http://fab.cba.mit.edu/classes/863.16/doc/projects/ftsmin/windows_avr.html"
          }
        >
          Windows Setup
        </Link>{" "}
        instructions to setup my Windows 10 PC.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./fabisp/usbasp.jpg"
            alt="tinyisp"
          />
        </div>
      </Typography>
      <Typography className={classes.para} paragraph>
        I used the firmware provided by Mr. Brian. I changed the make file to
        use USBasp programmer.
        <br />
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabisp_1.png"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        Then I used 'make' command to create .hex file.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabisp_2.png"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        Then 'make flash' command to burn the firmware.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabisp_3.png"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        Then 'make fuses' and 'make rstdisbl' commands to programs the fuse
        bits on the target chip and disable fuses respectively.
      </Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabisp_4.png"
          alt="tinyisp"
        />
      </div>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/fabisp_5.png"
          alt="tinyisp"
        />
      </div>
      <Typography className={classes.para} paragraph>
        Now the programmer is ready to program other ICs.
      </Typography>
    </div>
  );
};

export default withStyles(styles)(materials);
